module.exports = __webpack_public_path__ + "static/media/hands_24.c39c07d5.svg";